import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import properties from '../../../../modules/ajio-util/properties';
import {
  luxeGtmProductClick,
  luxeGtmProductImpressions,
  getStoreName
} from '../../../../modules/ga/GTMdatalayer';
import * as actions from '../../../../actions/productData';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag,
  getLuxeFlags
} from '../../../../Flags/selectors';
import PriceRevealPLP from '../../../common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { getIsPriceRevealPDP, getShowPriceRevealOnSimilar } from '../../../../utils/pdp';
import { addCustomerType } from '../../../../utils/products';
import { redirect } from '../../../../refresh/utils/cartUtils';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { getStoresForHidingMRP, getGiftWithProductEnable, getGiftWithProductConfig, getEnableComingSoonProducts } from '../../../../refresh/selectors/featureFlagsSelector';
import { displayValueWithSymbol } from '../../../../utils/price';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../../utils/product';
import luxeList from '../../../../refresh/constants/luxeScreenType';
import { getVariant } from '../../../../refresh/organism/ABFeature/Feature';
import { readCookie } from '../../../common/Cookie';
import { catalogIdToStoreName } from '../../../../utils';
import { replaceWithJioCDN } from '../../../../../src/utils/imageHandling';

let ajioUrl = properties.getProperty('parentUrl');
const luxeUrl = properties.getProperty('luxeURL');
const streetURL = properties.getProperty('streetURL');

class CrossSell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialIndex: 4,
      previousIndex: 0,
      hasObserverBlockCall: false,
      isViewItem: false
    };
    this.crossSellViewedBlockRef = React.createRef();
  }

  openModal(prodData, e) {
    if (e) e.preventDefault();
    this.props.openModal(prodData);
  }

  componentDidUpdate(prevProps, prevState) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { hasObserverBlockCall } = this.state;
        if (entry.isIntersecting && !hasObserverBlockCall) {
          this.setState({ hasObserverBlockCall: !hasObserverBlockCall }, () => {
            this.handleObserver();
          });
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (this.crossSellViewedBlockRef.current) observer.observe(this.crossSellViewedBlockRef.current);
  }

  handleObserver = () => {
    const {crossSellData,productData } = this.props;
    const { isViewItem } = this.state;
    if (crossSellData && crossSellData?.products.length >= 10) 
      {
        this.productImpressionsEventPush(crossSellData.products.slice(0),productData);
        this.setState({isViewItem: true})
      }
  };

  productImpressionsEventPush = (crossSellData,productData) => {
    const { newDesignLuxe, isNewProductTag, currentStore, enableGiftWithProduct } = this.props;
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const catalogNames = [];
    let impressions = crossSellData.map((data, index) => {
      const {
        name: description,
        brand,
        code = '',
        price: { value: priceValue = '' },
        fnlColorVariantData: {
          colorGroup: productColor = '',
          exclusiveTill: isExclusive = '',
          productTag = ''
        } = {},
        brickCategory: productCategory = '',
        brickName,
        discount = '',
        tags: { categoryTags = [] } = {},
        catalogName = '',
        segmentId = '',
        experimentId = '',
        offerPrice = {}
      } = data;

      const { giftAvailable = false } = offerPrice;
      catalogNames.push(catalogName);
      const productId = code && code.length > 9 ? code.substring(0, 9) : code;
      const tag = isExclusive ? 'Exclusive' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      return {
        name: description,
        id: productId,
        price: priceValue,
        brand,
        category: productCategory,
        list: 'pdp-cross-sell-Best Paired With', // example only,
        position: index,
        dimension6: productData?.name, // pass value for product_name
        dimension7: productData?.baseProduct, // pass value for product_id
        dimension8: productData?.brandName, // pass value for product_brand
        dimension9: productData?.price?.value, // pass value for product_price
        dimension10: productData?.fnlColorVariantData?.color, // pass value for product_color
        dimension11: '', // pass value for product_size
        dimension12: '', // pass value for product_trade_discount
        dimension13: productData?.brickSubCategory, // pass value for product_category
        dimension14: productData?.brickCode, // pass value for product_brick
        dimension15: tag, // pass value for product_tag
        dimension16: currentStore, // pass value for Store_type
        dimension23: catalogIdToStoreName(catalogName),
        dimension89: getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
        dimension60: dimension60Data,
        dimension90: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
        dimension91: '',
        dimension82: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
      };
    });
    luxeGtmProductImpressions({
      impressions,
      list: 'pdp screen',
      store_type: 'AJIO',
      page_name: screenName,
      page_type: screenType,
      contains_luxe: true,
      ProductArray: impressions
    });
  };

  onNextClick = index => {
    const { crossSellData,productData} = this.props;
    const { initialIndex, previousIndex } = this.state;
    if (index + 1 > initialIndex) {
      this.setState({ initialIndex: initialIndex + 4, previousIndex: previousIndex + 4 });
      //this.productImpressionsEventPush(crossSellData.slice(previousIndex + 4, initialIndex + 4),productData);
    }
  };

  render() {
    const {
      product = {},
      metaData = {},
      crossSellData,
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData = {},
      store,
      priceRevealLUXEFlag,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      isNewProductTag,
      productData,
      storesForHidingMRP,
      enableGiftWithProduct,
      giftWithProductConfig,
      comingSoonFlag = false
    } = this.props;
    const { priceRevealMetaInfo } = crossSellData || {};
    const { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};
    const isPriceReveal = getIsPriceRevealPDP(
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      priceRevealMetaInfo,
      store,
      priceRevealLUXEFlag
    );
    const isPriceRevealPDP = getShowPriceRevealOnSimilar(saleStartTime, saleEndTime);
    const data = Object.keys(product).length === 0 ? '' : product;
    const { isViewItem } = this.state;
    if (Object.keys(data).length === 0) {
      return null;
    }
    return (
      <div className="comp-section recently-viewed" ref={this.crossSellViewedBlockRef} role="group" aria-labelledby='best-paired-with-header'>
        <h3 className="align-center" role='heading' aria-level={2}>
          <span id="best-paired-with-header">
            <strong>Best Paired With</strong>
          </span>
        </h3>
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={data}
          crossSellData = {crossSellData?.products}
          isViewItem = {isViewItem}
          productData={productData}
          openModal={this.openModal.bind(this)}
          metaData={metaData}
          isPriceReveal={isPriceReveal}
          isPriceRevealPDP={isPriceRevealPDP}
          luxeEventPush={luxeEventPush}
          newDesignLuxe={newDesignLuxe}
          currentStore={currentStore}
          onNextClick={this.onNextClick}
          isNewProductTag={isNewProductTag}
          enableGiftWithProduct={enableGiftWithProduct}
          giftWithProductConfig={giftWithProductConfig}
        />
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div className={className} style={{ display: arrow, textAlign: 'center' }} onClick={onClick} />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div className={className} style={{ display: arrow, textAlign: 'center' }} onClick={onClick} />
  );
}

class DataList extends React.Component {
  render() {
    const isPdpPage = window.location.href.includes('/p/');
    let { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    if (!isPdpPage) {
      screenType = luxeScreen.plp.screenType;
      screenName = luxeScreen.plp.screenName;
    }
    const {
      pdpList: { recentlyList = '' }
    } = luxeList;
    let {
      metaData: { sis = false, name = '' } = {},
      isPriceReveal,
      isPriceRevealPDP,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      onNextClick,
      isNewProductTag,
      storesForHidingMRP,
      enableGiftWithProduct,
      giftWithProductConfig,
      productData,
      crossSellData,
      isViewItem,
    } = this.props;

    let addClass = '';
    let slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      afterChange: onNextClick
    };
    if (this.props.data.length < 4) {
      addClass = 'small-centered columns';
    }

    var dataListItems = this.props.data.map((data, index) => {
      let image;
      data.images.map((img, i) => {
        if (img.format === 'productGrid3ListingImage') {
          image = img.url;
        }
      });
      let {
        colorGroup,
        exclusiveTill = '',
        productTag = '',
        brandName = ''
      } = data.fnlColorVariantData;
      let { tags: { categoryTags = [] } = {} } = data;
      const productTagValue = exclusiveTill ? 'EXCLUSIVE' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const { offerPrice = {}, catalogName } = data;
      const { displayformattedValue = '', priceReveal = {}, value: offerValue = '', giftAvailable = false } = offerPrice;
      const redirectFn = redirect(data.url);
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
      const { name = '' } = data;

      function productImpressionsEventPush(crossSellData,productData){
        const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
        const catalogNames = [];

        const {
          name: description,
          brand,
          code = '',
          price: { value: priceValue = '' },
          fnlColorVariantData: {
            colorGroup: productColor = '',
            exclusiveTill: isExclusive = '',
            productTag = ''
          } = {},
          brickCategory: productCategory = '',
          brickName,
          discount = '',
          tags: { categoryTags = [] } = {},
          catalogName = '',
          segmentId = '',
          experimentId = '',
          offerPrice = {}
        } = crossSellData;

          const { giftAvailable = false } = offerPrice;
          catalogNames.push(catalogName);
          const productId = code && code.length > 9 ? code.substring(0, 9) : code;
          const tag = isExclusive ? 'Exclusive' : productTag;
          const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
          const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
          const dimension60Data =
            Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';

          const impression =  {
            name: description,
            id: productId,
            price: priceValue,
            brand,
            category: productCategory,
            list: 'pdp-cross-sell-Best Paired With', // example only,
            position: index,
            dimension6: productData?.name, // pass value for product_name
            dimension7: productData?.baseProduct, // pass value for product_id
            dimension8: productData?.brandName, // pass value for product_brand
            dimension9: productData?.price?.value, // pass value for product_price
            dimension10: productData?.fnlColorVariantData?.color, // pass value for product_color
            dimension11: '', // pass value for product_size
            dimension12: '', // pass value for product_trade_discount
            dimension13: productData?.brickSubCategory, // pass value for product_category
            dimension14: productData?.brickCode, // pass value for product_brick
            dimension15: tag, // pass value for product_tag
            dimension16: 'ajio', // pass value for Store_type
            dimension23: catalogIdToStoreName(catalogName),
            dimension89: getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
            dimension60: dimension60Data,
            dimension90: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
            dimension91: '',
            dimension82: ''
          };
        luxeGtmProductImpressions({
          impressions: impression,
          list: 'pdp screen',
          store_type: 'AJIO',
          page_name: screenName,
          page_type: screenType,
          contains_luxe: true,
          ProductArray: [impression]
        });
      };

      return (
        <Col key={index} className={addClass}>
          <a
            // href={addCustomerType(data.url)}
            className="prod-sec"
            target="_self"
            rel=""
            href="#"
            onClick={e => {
              e.preventDefault();
              if(!isViewItem){
                productImpressionsEventPush(crossSellData[index],productData);
              }
              luxeGtmProductClick({
                name: productData?.name,
                id: productData?.baseProduct,
                price: productData?.wasPriceData.displayformattedValue,
                brand: productData?.fnlColorVariantData.brandName,
                position: index,
                category: productData?.brickSubCategory,
                product_size: '',
                product_color: productData?.fnlColorVariantData.colorGroup
                  ? productData?.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_trade_discount: productData?.discountPercent,
                product_brick: productData?.brickCode,
                product_tag: isNewProductTag ? productTagEngineValue : productTagValue,
                list: 'pdp-cross-sell-Best Paired With',
                store_type: currentStore,
                pageType: screenType,
                pageName: screenName,
                sourceStore: catalogIdToStoreName(catalogName),
                containsLuxe: true,
                productPriceLabel: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
                productTagEngineValue: getVariant('enable_urgency_driver_pdp')
                  ? productTagEngineValue
                  : '',
                catalog: catalogName,
                segmentId: productData?.segmentId,
                experimentId: productData?.experimentId,
                offerName: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
              });
              redirectFn();
              window.location.href =  addCustomerType(data.url);
            }}
          >
            <div className="sec-prod-disp">
              <img
                className="sec-img"
                src={`${replaceWithJioCDN(image)}`}
                alt=""
                width="204px"
                height="256px"
              />

              {isNewProductTag && productTagEngineValue ? (
                <div
                  className={
                    newDesignLuxe ? 'luxe-sec-prod-exclusive-new' : 'sec-prod-exclusive-new'
                  }
                >
                  {productTagEngineValue}
                </div>
              ) : productTagValue ? (
                <div className="sec-prod-exclusive" aria-label={productTagValue}>{productTagValue}</div>
              ) : (
                ''
              )}
              {data.fnlColorVariantData.allPromotions ? <div className="sec-prod-offer" /> : ''}

              <div
                id="quickview"
                className="prod-quickview"
                role="button"
                tabIndex={0}
                onClick={e => {
                  e.stopPropagation();
                  this.props.openModal(colorGroup);
                }}
              >
                <span>QUICK VIEW</span>
              </div>
            </div>

            <div 
              className="sec-product-details" 
              aria-labelledby="sec-prod-title-cross-sell sec-prod-subtitle-cross-sell sec-prod-cp-cross-sell"
            >
              <div className="sec-prod-title" id="sec-prod-title-cross-sell" aria-hidden="true">
                <strong>{data.fnlColorVariantData.brandName}</strong>
              </div>
              <div className="sec-prod-subtitle" id="sec-prod-subtitle-cross-sell" aria-hidden="true">
                {data.name}
              </div>
              {data.price && data.price.displayformattedValue ? (
                <div className="sec-prod-cp" id="sec-prod-cp-cross-sell" aria-hidden="true">
                  {displayValueWithSymbol(data.price.displayformattedValue)}
                </div>
              ) : (
                ''
              )}

              {data.wasPriceData &&
              data.wasPriceData.value &&
              data.wasPriceData.value > data.price.value &&
              hideMRP ? (
                <div className="sec-prod-price">
                  <span className="sec-prod-sp">
                    <span>{displayValueWithSymbol(data.wasPriceData.displayformattedValue)}</span>
                  </span>
                  &nbsp;
                  <span className="discount-percent">&nbsp;({data.discountPercent})</span>
                </div>
              ) : (
                ''
              )}
              {/* Add GWP Here for product widget for Desktop */}
              {enableGiftWithProduct && giftAvailable &&
                <div className='gwp-container'>
                  <span className={newDesignLuxe ? 'gwp-text-luxe' : 'gwp-text'}>{giftWithProductConfig.productWidgetTitle}</span>
                </div>
              }
              {isPriceReveal && (
                <PriceRevealPLP
                  priceRevealClass="pr-pdp-desktop"
                  isPriceRevealPDP={isPriceRevealPDP}
                  priceReveal={priceReveal}
                  orignalPrice={data.price.value}
                  offerValue={offerValue}
                  deviceType="desktop"
                  pageType={isPdpPage ? 'pdp' : ''}
                  luxe={newDesignLuxe}
                  hasLineBreak={!!(newDesignLuxe && isPdpPage)}
                />
              )}
            </div>
          </a>
        </Col>
      );
    });

    if (this.props.data.length > 4) {
        return (
          <Slider {...slickSettings} ref="slick">
            {dataListItems}
          </Slider>
        );
      }
  
      return <Row>{dataListItems}</Row>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {}, metaData = {} } = state;
  const { sis, name } = metaData;
  const storeName = getCurrentStore(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    product: state.product.crossSellData?.products,
    crossSellData: state.product.crossSellData,
    metaData: state.metaData,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    store: sis ? name : 'AJIO',
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    currentStore: storeName,
    newDesignLuxe,
    storesForHidingMRP: getStoresForHidingMRP(state),
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    comingSoonFlag: getEnableComingSoonProducts(state?.flags)
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const productId = ownProps.productCode;
  const crossSellObj = {
    productCode: ownProps.productCode,
    brick: ownProps.brickVal
  }
  return {
    fetchData: setTimeout(function() {
      dispatch(actions.getCrossSell(crossSellObj));
    }, 500),
    openModal: productId => dispatch(actions.openModal(productId))
  };
};

export default CrossSell = connect(mapStateToProps, mapDispatchToProps)(CrossSell);
